import ProviderTable from './_table.js'
import template from './index.pug'

export default Vue.extend({
  template: template(),
  components: {
    ProviderTable
  },
  data() {
    return {
      providers: [],
      meta: {}
    }
  },
  created() {
    this.$setPageTitle(this.$t('providerLeads.index.title'))
    this.$setBreadcrumbs([
      {label: this.$t('breadcrumbs.provider-leads.index'), route: {}}
    ])
  },
  methods: {
    loadProviders(queryOptions = {}) {
      API.providerLeads.index(queryOptions).then(({data, meta}) => {
        this.providers = data
        this.meta = meta
      })
    }
  }
})
